class BlogSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.swiper');
    this.enableSlider = this.dataset.enableSlider === 'true';
    this.items = parseInt(this.dataset.items) || 3;
    this.tabletItems = parseInt(this.dataset.tabletItems) || 2;
    this.totalItems = parseInt(this.dataset.totalItems) || 0;

    console.log('=== BLOG SLIDER CONSTRUCTOR ===');
    console.log('enableSlider:', this.enableSlider);
    console.log('items (desktop):', this.items);
    console.log('tabletItems:', this.tabletItems);
    console.log('totalItems:', this.totalItems);
    console.log('slider element:', this.slider);

    if (this.slider && this.enableSlider) {
      this.initSlider();
    } else {
      console.log('Slider NOT initialized - enableSlider:', this.enableSlider, 'slider exists:', !!this.slider);
    }
  }

  initSlider() {
    console.log('=== INITIALIZING SWIPER ===');

    const slides = this.slider.querySelectorAll('.swiper-slide');
    console.log('Number of slides in DOM:', slides.length);
    console.log('Swiper wrapper classes:', this.slider.querySelector('.swiper-wrapper').className);
    console.log('First slide classes:', slides[0] ? slides[0].className : 'N/A');
    console.log('Slider container width:', this.slider.offsetWidth + 'px');

    const sliderOptions = {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      loopAdditionalSlides: 3,
      loopedSlides: this.totalItems,
      speed: 600,
      grabCursor: true,
      touchRatio: 1,
      touchAngle: 45,
      allowTouchMove: true,
      watchSlidesProgress: true,
      slidesPerGroup: 1,
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        type: 'progressbar',
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: this.tabletItems,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: this.items,
          spaceBetween: 28,
        },
        1280: {
          slidesPerView: this.items,
          spaceBetween: 32,
        },
        1536: {
          slidesPerView: this.items,
          spaceBetween: 36,
        },
        1920: {
          slidesPerView: this.items,
          spaceBetween: 40,
        }
      },
      on: {
        init: function() {
          console.log('=== SWIPER INITIALIZED ===');

          // Debug spécifique : description coupée
          setTimeout(() => {
            console.log('\n=== DEBUG DESCRIPTION (EXCERPT) ===');
            const cards = document.querySelectorAll('blog-slider .article-card');
            cards.forEach((card, index) => {
              if (index < 3) {
                console.log(`\n📄 Card #${index + 1}:`);

                const cardRect = card.getBoundingClientRect();
                const content = card.querySelector('.article-card__content');
                const excerpt = card.querySelector('.article-card__excerpt');
                const button = card.querySelector('.article-card__button');

                if (content && excerpt) {
                  const contentRect = content.getBoundingClientRect();
                  const excerptRect = excerpt.getBoundingClientRect();
                  const excerptStyle = window.getComputedStyle(excerpt);

                  console.log('  📋 EXCERPT:');
                  console.log('     Height:', excerpt.offsetHeight + 'px');
                  console.log('     ScrollHeight (contenu réel):', excerpt.scrollHeight + 'px');
                  console.log('     max-height CSS:', excerptStyle.maxHeight);
                  console.log('     line-height:', excerptStyle.lineHeight);
                  console.log('     -webkit-line-clamp:', excerptStyle.webkitLineClamp);
                  console.log('     overflow:', excerptStyle.overflow);
                  console.log('     Top (relative to card):', Math.round(excerptRect.top - cardRect.top) + 'px');
                  console.log('     Bottom (relative to card):', Math.round(excerptRect.bottom - cardRect.top) + 'px');

                  const isOverflowing = excerpt.scrollHeight > excerpt.offsetHeight;
                  console.log('     📊 Débordement:', isOverflowing ? '⚠️ TEXTE COUPÉ!' : '✅ TOUT VISIBLE');
                  if (isOverflowing) {
                    console.log('        Texte caché:', (excerpt.scrollHeight - excerpt.offsetHeight) + 'px');
                  }

                  // Vérifier s'il y a un élément blanc qui cache
                  const afterExcerpt = button ? button : null;
                  if (afterExcerpt) {
                    const afterRect = afterExcerpt.getBoundingClientRect();
                    const gap = afterRect.top - excerptRect.bottom;
                    console.log('\n  📏 ESPACE Excerpt → Bouton:', Math.round(gap) + 'px');
                  }

                  // Vérifier le content overflow
                  const contentStyle = window.getComputedStyle(content);
                  console.log('\n  📦 CONTENT:');
                  console.log('     Height:', content.offsetHeight + 'px');
                  console.log('     max-height:', contentStyle.maxHeight);
                  console.log('     overflow:', contentStyle.overflow);
                  console.log('     Card height:', card.offsetHeight + 'px');

                  const contentOverflow = contentRect.bottom - cardRect.bottom;
                  if (contentOverflow > 0) {
                    console.log('     ⚠️ Content dépasse la card de:', Math.round(contentOverflow) + 'px');
                  }
                }
              }
            });
          }, 100);
        },
        breakpoint: function(swiper, breakpointParams) {
          console.log('=== BREAKPOINT CHANGED ===');
          console.log('New slidesPerView:', breakpointParams.slidesPerView);
          console.log('New spaceBetween:', breakpointParams.spaceBetween);
        }
      }
    };

    // Utiliser le système Carousel du thème FoxTheme
    this.swiper = new window.FoxTheme.Carousel(this.slider, sliderOptions);
    this.swiper.init();

    console.log('Swiper instance created:', this.swiper);
  }
}

customElements.define('blog-slider', BlogSlider);
